import { Component, Input } from '@angular/core';
import { Style } from '@app/shared/components/atoms/icon/icon.component';

@Component({
  selector: 'app-menu-navigation',
  templateUrl: './menu-navigation.component.html',
  styleUrls: ['./menu-navigation.component.scss'],
  standalone: false,
})
export class MenuNavigationComponent {
  @Input() isMenuOpen = true;
  protected readonly Style = Style;
}
